import React from 'react';
import {
  pathname,
  applicationStatus,
  formatDateForDisplay,
  formatNumber,
  noData,
} from '../../utils';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import BottomLine from './PlanDiscovery/BottomLine';
import Stats from './PlanDiscovery/Stats';
import PaymentsTable from '../PaymentsTwo/PaymentsTable';
import {
  SummaryPendingHasOriginApp,
  SummaryPendingNewApp,
} from './SummaryPending';

const useStyles = makeStyles((theme: any) => ({
  section: { marginLeft: theme.spacing(0.25) },
  spacing: { marginTop: theme.spacing(2) },
  linesLink: { '&:hover': { cursor: 'pointer' } },
  active: { color: theme.palette.status.active },
  bold: { fontWeight: 'bold' },
  zeroMargin: { marginBottom: 0 },
  summaryMargin: { marginBottom: theme.spacing(1) },
  buttonSection: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export default function Summary({
  plan,
  openContract,
  openContractAddendum,
  rejectEditedPlan,
}) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <React.Fragment>
      {plan.status === applicationStatus.complete.status && (
        <React.Fragment>
          <Typography variant="h4" paragraph>
            Well done!{' '}
          </Typography>
          <Typography paragraph>
            You completed this Growth Plan
            {plan?.end && ` on ${formatDateForDisplay(plan?.end, false)}`}. To
            receive a new custom Growth Plan, please create{' '}
            <Link
              className={classes.linesLink}
              onClick={() => {
                history.push(pathname.lines.url);
              }}
            >
              new Lines
            </Link>
            .
          </Typography>
        </React.Fragment>
      )}
      {plan.status === applicationStatus.active.status && (
        <React.Fragment>
          <Typography variant="h6" paragraph className={classes.active}>
            {plan?.activatedAt
              ? `Plan activated on ${formatDateForDisplay(
                  plan?.activatedAt,
                  false,
                )}.`
              : 'Plan is active.'}
          </Typography>
        </React.Fragment>
      )}
      {plan.status === applicationStatus.pending.status &&
      plan.originApplication ? (
        <SummaryPendingHasOriginApp
          plan={plan}
          rejectEditedPlan={rejectEditedPlan}
          openContractAddendum={openContractAddendum}
          classes={classes}
        />
      ) : (
        <SummaryPendingNewApp
          plan={plan}
          rejectEditedPlan={rejectEditedPlan}
          openContract={openContract}
          classes={classes}
        />
      )}
      <Typography
        variant="h4"
        paragraph
        className={
          classes.spacing + ' ' + classes.bold + ' ' + classes.zeroMargin
        }
      >
        Summary of plan {plan.displayName}
      </Typography>
      <Typography className={classes.summaryMargin}>
        {plan?.originApplication && plan?.expiresIn && (
          <span>(replacing plan {plan.originDisplayName})</span>
        )}
      </Typography>
      <div className={classes.section}>
        <BottomLine plan={plan} />
        <Stats plan={plan} />
      </div>
      {plan?.payments && (
        <React.Fragment>
          <Typography variant="h4" gutterBottom>
            {pathname.remittance.label}
          </Typography>
          <div className={classes.section}>
            <Typography paragraph>
              Your Growth Plan includes access to{' '}
              <b>{plan?.total ? '$' + formatNumber(plan.total) : noData()}</b>.
              Your custom {pathname.remittance.label} was generated to ensure
              your cash flow remains stable.
            </Typography>
          </div>
          <PaymentsTable
            payments={plan?.payments}
            debit={plan?.currentDebit}
            onGoingPayments={plan?.currentOngoing}
            includeFilters={false}
            includeStatus={false}
            planStatus={plan?.status}
            splitPaymentTable={
              plan?.status === applicationStatus.pending.status &&
              plan?.originApplication
            }
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
